export function parsePhotoUrls(value) {
  if (!value) return [];
  if (Array.isArray(value)) {
    return value
      .map((item) => (item == null ? '' : String(item).trim()))
      .filter((item) => item.length > 0);
  }
  return String(value)
    .split(/[\n,;]/)
    .map((item) => item.trim())
    .filter((item) => item.length > 0);
}

function extractOptionLabel(option) {
  if (option == null) return '';
  if (typeof option === 'string') return option.trim();
  if (typeof option === 'number') return String(option);
  if (typeof option === 'object') {
    for (const key of ['text', 'title', 'label', 'name']) {
      if (option[key]) return String(option[key]).trim();
    }
  }
  return String(option).trim();
}

export function normalizeInventoryTask(raw) {
  if (!raw || typeof raw !== 'object') return null;
  const parcelId = raw.parcelId ?? raw.parcelID ?? raw.parcel_id ?? raw.id;
  if (!parcelId) return null;
  const parcelNumber = raw.parcelNumber ?? raw.parcel_number ?? raw.barcode ?? raw.miniSticker ?? null;
  const resultOptionsRaw = raw.resultOptions ?? raw.buttons ?? null;
  const options = Array.isArray(resultOptionsRaw)
    ? resultOptionsRaw.map(extractOptionLabel).filter((item) => item.length > 0)
    : [];
  return {
    parcelId: String(parcelId),
    parcelNumber: parcelNumber != null ? String(parcelNumber) : null,
    operationId: raw.operationId ?? raw.operationID ?? raw.taskId ?? raw.inventoryId ?? null,
    status: raw.status ?? raw.resultText ?? null,
    resultText: raw.resultText ?? null,
    resultOptions: options,
    notes: raw.notes ?? null,
    startedAt: raw.startedAt ?? raw.createdAt ?? null,
    completedAt: raw.completedAt ?? null,
    raw,
  };
}

export function inventoryTaskKey(task) {
  if (!task) return '';
  return `${task.operationId ?? ''}|${task.parcelId ?? ''}`;
}

export function buildInventoryPayload(task, formState) {
  if (!task || !task.parcelId) {
    throw new Error('Invalid task payload');
  }
  const completed = !!(formState?.completed ?? true);
  const resultRaw = formState?.resultText ?? '';
  const resultText = String(resultRaw).trim();
  if (!resultText) {
    throw new Error('Порожній результат');
  }
  const payload = {
    parcelId: task.parcelId,
    completed,
    resultText,
  };
  const notes = formState?.notes != null ? String(formState.notes).trim() : '';
  if (notes) payload.notes = notes;
  const photoSource = formState?.photoUrls ?? formState?.photoInput ?? '';
  const photoUrls = parsePhotoUrls(photoSource);
  if (photoUrls.length) payload.photoUrls = photoUrls;
  return payload;
}
